import { ethnicityList } from "../helper";
import FilterMultiSelectBox from "./filterMultiSelectBox";
import { useEthnicityFilter } from "../filters/useEthnicityFilter";

const FilterEthnicity = ({ talentFilter, talentFilterTags, onAddFilter }) => {
  const {
    values,
    setValues,
    isDisabled,
    buildEthnicityFilter,
  } = useEthnicityFilter(talentFilter, talentFilterTags);

  const handleAdd = () => {
    const payload = buildEthnicityFilter();
    if (!payload) return;

    onAddFilter("ethnicity", payload);
  };

  return (
    <FilterMultiSelectBox
      title="ETHNICITY (Select one or several)"
      label="Select ethnicity or search"
      list={ethnicityList}
      selectedValue={values}
      onChange={setValues}
      onAddFilter={handleAdd}
      btnContent="Add Filter"
      disabled={isDisabled}
    />
  );
};

export default FilterEthnicity;
